module.exports = {"id":"166710","name":"Ilya Maksimov","rating":"74","photo":"./data/images/photos/1/166710.png","club":{"name":"Arsenal Tula","logo":"./data/images/clubs/ArsenalTula.png"},"positions":["MOC","MC","BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IlyaMaksimov0.json
// module id = 1801
// module chunks = 0